import * as message from './message'

export const jobInviteHelper = {
  message,
}
